import Modal from "react-bootstrap/Modal";
import React, {useEffect, useRef, useState} from "react";
import {Button} from "react-bootstrap";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import axios from "axios";
import {setNewDcl} from "../../../../_reducers/DataPanel/Dcl/dclSlice";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import useMediaQuery from "../../../../hooks/useMediaQuery";

const RecognizePlateModal = ({show, setShow}) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [isSending, setIsSending] = useState(false);
    const apiURL2 = process.env.REACT_APP_API_URL2;
    const isMobileScreen = useMediaQuery("(max-width: 768px)");
    const newDclData = useSelector((state) => state.DCL.newDcl);
    const dispatch = useDispatch();
    // Start camera when modal opens
    useEffect(() => {
        if (show) {
            startCamera();
        } else {
            stopCamera();
        }
    }, [show]);

    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { exact: "environment" } } });
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
        } catch (error) {
            console.error('Error accessing camera:', error);
        }
    };

    const stopCamera = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const tracks = videoRef.current.srcObject.getTracks();
            tracks.forEach(track => track.stop());
            videoRef.current.srcObject = null;
        }
    };

    const captureImage = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (!video || !canvas) return;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const base64 = canvas.toDataURL('image/jpeg');
        sendImage(base64)
    };

    const pauseCamera = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const tracks = videoRef.current.srcObject.getTracks();
            tracks.forEach(track => track.enabled = false); // disable video feed
        }
    };

    const resumeCamera = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const tracks = videoRef.current.srcObject.getTracks();
            tracks.forEach(track => track.enabled = true); // enable video feed
        }
    };

    const sendImage = (base64) => {
        pauseCamera();
        if(!isEmpty(base64)) {
            setIsSending(true);
            axios.post(apiURL2 + `/dcl/recognize-plate-number`, {image: base64}, {
                headers: { "Content-Type": "application/json" },
            }).then((res) => {
                if (res.data.status === "200") {
                    toast.success("Ο Έλεγχος Πινακίδας ολοκληρώθηκε με επιτυχία!");
                    console.log(res.data.data);
                    dispatch(setNewDcl({...newDclData, vehicleRegistrationNumber: res.data.data, runCheckAfterRecognize: true}));
                    setShow(false);
                } else {
                    toast.error(res.data && res.data.message);
                }
                setIsSending(false);
            }).catch((error) => {
                console.log(error);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                setIsSending(false);
            })
        } else {
            toast.error("Παρακαλώ εισάγετε Πινακίδα Οχήματος!");
        }
        resumeCamera();
    }


    return (
        <Modal show={show} className={"themeModalMedium"} backdrop={"static"} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Αναγνώριση Πινακίδας</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{maxHeight: isMobileScreen ? "60vh" : "75vh", overflowY: 'auto', width: "100%", overflowX: isMobileScreen? 'auto' : 'hidden', padding: "2px"}}>
                <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    style={{ width: '100%', borderRadius: '8px', height: "70vh" }}
                />
                <canvas ref={canvasRef} style={{ display: 'none' }} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)}>
                    Κλείσιμο
                </Button>
                    <Button disabled={isSending} variant="primary" onClick={() => captureImage()}>
                        Έλεγχος Πινακίδας
                    </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RecognizePlateModal;